<template src="../templates/navbar.pug" lang="pug"></template>
<style src="../sass/navbar.sass" lang="sass" scoped></style>

<script>
import localforage from 'localforage'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Navbar',
    data() {
        return {
            cattleRoutes: ['cattle', 'cattle-log', 'fecondity', 'milk-inspection', 'culled'],
            showDrawer: true
        }
    },
    computed: {
        ...mapGetters([
            'selectedFarm',
            'profile',
            'isUserVisitor',
            'isMobile',
            'cattleLoading',
            'bullLoading',
            'culledLoading'])
    },
    created() {
        if(this.isMobile) {
            this.showDrawer = false
        }
    },
    methods: {
        ...mapMutations(['reset']),
        ...mapActions(['fetchFarms']),
        logout() {
            this.reset()
            localforage.clear()
            this.$router.push('/')
        },
        goToDashboard() {
            if(this.$route.name === 'dashboard') {
                this.fetchFarms()
            } else {
                this.$router.push('/dashboard')
            }
        },
        toogleDrawer() {
            this.showDrawer = !this.showDrawer
        }
    }
}
</script>


